export const ModalSize = ['sm', 'md', 'lg', 'xl', 'full-screen'];
//# sourceMappingURL=modal.js.map